<template>
  <div class="flex operation_area">
    <el-select v-model="from" :disabled="disabledLeft">
      <el-option
        v-for="item in left"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div class="icon flex_default_center">
      <i class="el-icon-sort"></i>
    </div>
    <el-select v-model="to" :disabled="disabledRight">
      <el-option
        v-for="item in left"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-button
      class="border-btn"
      :loading="load"
      size="small"
      style="margin-left: 20px;"
      plain
      @click="translateTextCus"
      >{{ $t("home.translate") }}</el-button
    >
  </div>
</template>

<script>
import { translate } from "@/api/api";

export default {
  name: "translate",
  props: {
    content: {
      type: String,
      default: "",
    },
    field: {
      type: String,
      default: "",
    },
    disabledLeft: {
      type: Boolean,
      default: false,
    },
    disabledRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      left: [
        {
          value: "zh-CHS",
          label: "中文",
        },
        {
          value: "en",
          label: "English",
        },
        {
          value: "ko",
          label: "한국어",
        },
        {
          value: "fa",
          label: "فارسی",
        },
        {
          value: "ru",
          label: "русск",
        },
        {
          value: "es",
          label: "español",
        },
        {
          value: "tr",
          label: "Turkish",
        },
        {
          value: "it",
          label: "italiano",
        },
        {
          value: "vi",
          label: "Việt nam",
        },
      ],
      right: [
        {
          value: "zh-CHS",
          label: "中文",
        },
      ],
      load: false,
      from: "",
      to: "",
    };
  },
  mounted() {
    this.from = this.left[0]?.value;
    this.to = this.left[1]?.value;
  },
  methods: {
    //点击翻译
    async translateTextCus() {
      try {
        this.load = true;
        let query = {
          data: {
            text: this.content,
            sourceLanguage: this.from,
            targetLanguage: this.to,
          },
        };
        const res = await translate(query);
        if (res.status == 0) {
          this.$emit("getTranslateVal", this.field, res.data);
        } else {
          this.$DonMessage.error("第三方接口反馈出错，请点击翻译按钮重试");
        }
        this.load = false;
      } catch (error) {
        this.load = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.operation_area {
  display: flex;
  // padding-left: 10px;
  align-items: center;
  justify-content: space-between;
  // margin-top: 30px;
  ::v-deep .el-input {
    width: 100px !important;
  }
}
</style>
